import type { RouteRecordRaw } from 'vue-router';
import TaskView from '@Views/TaskView.vue';
import InviteView from '@Views/InviteView.vue';

export const createRoutes = (basePath: string): RouteRecordRaw[] => [
    {
        path: `${basePath}/dashboard`,
        name: 'task-view',
        component: TaskView,
        meta: { requiresAuth: true },
    },
    {
        path: `${basePath}/dashboard/deal/:dealId`,
        name: 'deal-tasks',
        component: TaskView,
        meta: { requiresAuth: true },
    },
    {
        path: `${basePath}/dashboard/invite`,
        name: 'invite',
        component: InviteView,
    },
];
